var _g, _circle, _g2, _circle2, _circle3, _path, _rect, _rect2, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 97,
    viewBox: "0 0 84 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3525_32725)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3525_32725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0642 11.0357C13.6536 8.60783 15.289 6.3068 17.7169 5.89622L40.1368 2.10472L49.3685 0.543509C51.7964 0.132924 54.0974 1.76826 54.508 4.19614L55.2514 8.59219C55.662 11.0201 57.963 12.6554 60.3909 12.2448L64.787 11.5014C67.2148 11.0908 69.5159 12.7261 69.9265 15.154L73.1232 34.0571L78.5503 66.1483C78.9609 68.5762 77.3255 70.8772 74.8976 71.2878L30.0578 78.8708C27.6299 79.2814 25.3289 77.6461 24.9183 75.2182L14.0642 11.0357Z",
    fill: "#3E6E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1874 18.1819C7.54685 15.8044 8.95499 13.3577 11.3326 12.7171L33.288 6.80209L42.3284 4.36649C44.706 3.72594 47.1527 5.13408 47.7932 7.51166L48.9531 11.8166C49.5936 14.1942 52.0403 15.6024 54.4179 14.9618L58.7228 13.802C61.1004 13.1614 63.5471 14.5696 64.1876 16.9472L69.1748 35.4586L77.6415 66.885C78.282 69.2625 76.8739 71.7092 74.4963 72.3498L30.5855 84.1799C28.2079 84.8204 25.7612 83.4123 25.1207 81.0347L8.1874 18.1819Z",
    fill: "#559F89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1536 39.7383L56.8714 30.9237",
    stroke: "white",
    strokeWidth: 2.67509,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 31.1279L34.7482 27.6485",
    stroke: "white",
    strokeWidth: 2.67509,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2412 47.4863L58.9591 38.6717",
    stroke: "white",
    strokeWidth: 2.67509,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3284 55.2354L61.0462 46.4208",
    stroke: "white",
    strokeWidth: 2.67509,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6482 63.8447L63.3661 55.0301",
    stroke: "white",
    strokeWidth: 2.67509,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3525_32725",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 25,
    width: 42,
    height: 42
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7205,
    cy: 45.9227,
    r: 18.4239,
    transform: "rotate(-72.2266 21.7205 45.9227)",
    fill: "white",
    stroke: "#696865",
    strokeWidth: 3.98007
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3525_32725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.57 47.1426L55.7253 36.3243M12.7228 36.575L28.5736 32.3046M18.1329 56.6522L58.2881 45.8339M57.9981 15.3099L52.7146 16.7333C49.7965 17.5195 46.7937 15.7913 46.0075 12.8732L44.5841 7.58963C43.7979 4.67158 40.7951 2.94335 37.877 3.7295L-0.164806 13.9784C-3.08285 14.7646 -4.81109 17.7674 -4.02493 20.6855L16.7576 97.8258C17.5437 100.744 20.5466 102.472 23.4646 101.686L77.3572 87.1667C80.2753 86.3805 82.0035 83.3777 81.2174 80.4596L64.7052 19.17C63.919 16.252 60.9162 14.5237 57.9981 15.3099Z",
    stroke: "white",
    strokeWidth: 3.28319,
    strokeLinecap: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5235,
    cy: 45.9754,
    r: 18.4239,
    transform: "rotate(-72.2266 21.5235 45.9754)",
    stroke: "#E2B134",
    strokeWidth: 3.98007
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5235,
    cy: 45.9754,
    r: 18.4239,
    transform: "rotate(-72.2266 21.5235 45.9754)",
    fill: "url(#paint0_linear_3525_32725)",
    stroke: "#E2B134",
    strokeWidth: 3.98007
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23561 39.3475C7.29097 29.816 17.7391 24.5503 27.6437 27.7253C37.5482 30.9004 42.9872 41.2586 39.9318 50.79C36.8764 60.3212 26.4294 65.5863 16.5249 62.4116C6.6204 59.2367 1.18051 48.8789 4.23561 39.3475Z",
    stroke: "#FDCA47",
    strokeWidth: 4.04897
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.1822,
    y: 54.1765,
    width: 5.48571,
    height: 18.4163,
    transform: "rotate(-72.2266 39.1822 54.1765)",
    fill: "#FDCA47",
    stroke: "#FDCA47",
    strokeWidth: 0.130612
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.137,
    y: 58.7197,
    width: 7.31427,
    height: 23.3796,
    rx: 1.30612,
    transform: "rotate(-72.2266 50.137 58.7197)",
    fill: "#F46C60"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6075,
    cy: 91.9875,
    rx: 33.2393,
    ry: 3.09203,
    fill: "#B0CDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3525_32725",
    x1: 41.9374,
    y1: 45.9754,
    x2: 1.10962,
    y2: 45.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.264423,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528846,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3525_32725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.7118,
    height: 96.626,
    fill: "white",
    transform: "translate(0.227539)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3525_32725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.3866,
    height: 81.1658,
    fill: "white",
    transform: "translate(3.71167 8.7334) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspect);
export default __webpack_public_path__ + "static/media/Inspect.e6a20144b84f74d75cf68941104c5b5c.svg";
export { ForwardRef as ReactComponent };